import { FC } from 'react';
import { useSession } from '@/components/SessionProvider';
import { hasPermission } from '@/utils/permission';
import { User } from '../../query';
import { Row } from './Row';
import styles from './UsersTable.scss';

interface UsersTableProps {
  users: User[];
  refetch: () => void;
}

export const UsersTable: FC<UsersTableProps> = ({ users, refetch }) => {
  const { user: currentUser } = useSession();
  const roleTypesColSpan = [
    hasPermission(currentUser, 'user_manage_edit_stress_check_roles'),
    hasPermission(currentUser, 'user_manage_edit_regular_health_checkup_roles'),
    hasPermission(currentUser, 'user_manage_edit_user_manage_roles')
  ].filter(v => v).length;

  return (
    <div className="l-overflow-scroll">
      <table className={styles.table}>
        <thead>
          <tr className={styles.header}>
            <th className={styles.staffCodeColumn} rowSpan={2}>
              スタッフコード
            </th>
            <th className={styles.nameColumn} rowSpan={2}>
              氏名
            </th>
            <th className={styles.emailColumn} rowSpan={2}>
              メールアドレス
            </th>
            <th className={styles.roleTypesColumn} colSpan={roleTypesColSpan}>
              権限
            </th>
            <th className={styles.actionsColumn} rowSpan={2}>
              アクション
            </th>
          </tr>
          <tr className={styles.header}>
            {hasPermission(currentUser, 'user_manage_edit_stress_check_roles') && (
              <th className={styles.roleTypeColumn}>ストレスチェック</th>
            )}
            {hasPermission(currentUser, 'user_manage_edit_regular_health_checkup_roles') && (
              <th className={styles.roleTypeColumn}>定期健康診断</th>
            )}
            {hasPermission(currentUser, 'user_manage_edit_user_manage_roles') && (
              <th className={styles.roleTypeColumn}>管理者追加・削除</th>
            )}
          </tr>
        </thead>
        <tbody>{users.length > 0 && users.map(user => <Row key={user.email} user={user} refetch={refetch} />)}</tbody>
      </table>
    </div>
  );
};
